// Theme configuration for Blue Quinceañera Dreams
export const theme = {
  colors: {
    // Sky Blue Primary Palette
    primary: {
      main: 'hsl(200, 80%, 60%)',
      light: 'hsl(200, 85%, 70%)',
      dark: 'hsl(200, 75%, 50%)',
      foreground: 'hsl(0, 0%, 100%)',
    },
    // Background Colors
    background: {
      main: 'hsl(40, 30%, 98%)',
      card: 'hsl(0, 0%, 100%)',
      muted: 'hsl(200, 20%, 94%)',
    },
    // Text Colors
    text: {
      primary: 'hsl(220, 30%, 15%)',
      secondary: 'hsl(220, 10%, 45%)',
      muted: 'hsl(220, 10%, 45%)',
    },
    // Accent Colors
    accent: {
      main: 'hsl(200, 60%, 92%)',
      gold: 'hsl(35, 70%, 55%)',
      goldDark: 'hsl(25, 60%, 45%)',
    },
    // Border Colors
    border: {
      main: 'hsl(200, 20%, 88%)',
      light: 'hsl(200, 20%, 95%)',
    },
    // Status Colors
    destructive: 'hsl(0, 84%, 60%)',
    success: 'hsl(142, 76%, 36%)',
    warning: 'hsl(38, 92%, 50%)',
  },
  typography: {
    fontFamily: {
      display: "'Playfair Display', serif",
      body: "'Lato', sans-serif",
    },
    fontSize: {
      xs: '0.75rem',
      sm: '0.875rem',
      base: '1rem',
      lg: '1.125rem',
      xl: '1.25rem',
      '2xl': '1.5rem',
      '3xl': '1.875rem',
      '4xl': '2.25rem',
      '5xl': '3rem',
      '6xl': '3.75rem',
      '7xl': '4.5rem',
      '8xl': '6rem',
      '9xl': '7.5rem',
      '10xl': '9rem',
    },
    fontWeight: {
      light: 300,
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
      extrabold: 800,
    },
  },
  spacing: {
    xs: '0.5rem',
    sm: '0.75rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    '2xl': '3rem',
    '3xl': '4rem',
    '4xl': '6rem',
  },
  borderRadius: {
    sm: '0.375rem',
    md: '0.5rem',
    lg: '0.75rem',
    xl: '1rem',
    '2xl': '1.5rem',
    '3xl': '2rem',
    full: '9999px',
  },
  shadows: {
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
    elegant: '0 10px 40px -10px hsl(200 60% 60% / 0.15), 0 4px 20px -5px hsl(200 60% 60% / 0.1)',
  },
  breakpoints: {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    '2xl': '1536px',
  },
  zIndex: {
    dropdown: 1000,
    sticky: 1020,
    fixed: 1030,
    modalBackdrop: 1040,
    modal: 1050,
    popover: 1060,
    tooltip: 1070,
  },
  transitions: {
    default: 'all 0.3s ease',
    fast: 'all 0.15s ease',
    slow: 'all 0.5s ease',
  },
};
